import { AST } from '@handlebars/parser';
import { NodeType } from '../../node/types';

export const isPathExpression = (expression: AST.Expression): expression is AST.PathExpression =>
  expression.type === NodeType.PathExpression;
